import { h, Component } from "preact";

import { classNames, uniqueID } from "../helpers";
import Icon from "./Icon.jsx";

export default function DropdownInput(props) {
  const id = props.id || props.name || uniqueID();
  return (
    <div
      class={classNames(
        "input-field dropdown-input",
        props.class,
        props.iconBefore && "dropdown-input--with-icon",
        props.label && "dropdown-input--with-label",
        props.error && "dropdown-input--invalid invalid"
      )}
    >
      {props.iconAfter && (
        <Icon class="dropdown-input__prefixIcon">{props.iconAfter}</Icon>
      )}

      <span class="dropdown-input__input">{props.children}</span>
      {props.label && (
        <label for={id} class={props.children ? "active" : ""}>
          {props.label}
          {props.mandatory && "*"}
        </label>
      )}

      {props.iconBefore && (
        <Icon class="dropdown-input__suffixIcon">{props.iconBefore}</Icon>
      )}
    </div>
  );
}
